import Reveal from 'stimulus-reveal'

// Connects to data-controller="reveal"
export default class extends Reveal {}
